// import { ConfirmModalService } from '@core/services';
import {NgRedux} from '@angular-redux/store';
import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import * as Store from '@core/redux/stores';
import {Actions} from '@core/redux/stores';
import {ConfirmationService} from 'primeng/api';
import {Observable} from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private confirmationService: ConfirmationService,
              private ngRedux: NgRedux<Store.IAppState>) {
  }

  canDeactivate(component: CanComponentDeactivate): boolean | Observable<boolean> {
    if (component.canDeactivate()) {
      return true;
    } else {
      return new Observable<boolean>(
        (observer) => {
          this.confirmationService.confirm({
            message: 'All information you’ve provided will be lost.',
            accept: () => {
              const contactDetailsData: Store.ContactUs = {
                topicName: null,
                visitInfo: null,
                userExperience: null,
                contactInformation: null,
              };
              this.ngRedux.dispatch({type: Actions.CONTACTUS, data: contactDetailsData});

              observer.next(true);
              observer.complete();
            },
            reject: () => {
              observer.next(false);
              observer.complete();
            }
          });
        });
    }
  }
}
